module.exports = __webpack_public_path__ + "./assets/img/marketing_m1.711ffaa2.png";